import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import InfoIcon from '@material-ui/icons/Info';
import Snackbar from '@material-ui/core/Snackbar';
import { SnackbarContent } from '@material-ui/core';

import useRoomState from '../../hooks/useRoomState/useRoomState';
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles({
  snackbar: {
    backgroundColor: 'rgb(33,147,134',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '0.8em',
    color: 'white'
  },
});

export default function ReconnectingNotification() {
  const classes = useStyles();
  const roomState = useRoomState();

  return (
    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={roomState === 'reconnecting'}>
      <SnackbarContent
        className={classes.snackbar}
        message={
          <span className={classes.message}>
            <CircularProgress style={{color:"white"}}/>
            <InfoIcon className={classes.icon}/>
            Reconnecting&hellip;
          </span>
        }
      />
    </Snackbar>
  );
}
